import { apiClient } from './api';

export const shippingApi = {
    getRate: async (rateRequest) => {
        const response = await apiClient.post('/shipping-rate/', rateRequest);
        return response.data;
    }
}
